import { APP_CONFIG } from './app';
import rollbar from './rollbar';
import GTMService from '../services/GTMService';
import { TechnicalErrorReportService } from '../services/TechnicalErrorReportService';

// Reporting is off outside production and staging, where it falls back to a console.warn. The
// `hostSafeList` in ./rollbar does not cover us here: it only filters items that carry a trace, and
// a warning built from a message string carries none, so localhost and CI would otherwise post
// straight into the production project.
TechnicalErrorReportService.configure({
  apiHost: APP_CONFIG.API_HOST,
  appName: APP_CONFIG.APP_NAME,
  gtmPush: GTMService.dataLayer.push,
  reportingEnabled: APP_CONFIG.production() || APP_CONFIG.staging(),
  rollbar
});